<template>
  <div>
    <el-dialog
      id="create-modal"
      class="form-modal"
      v-loading="createProcessing"
      :visible.sync="createVisible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
      @closed="resetFields"
    >
      <div id="create-modal-header" class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">Order Numbers</h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="orderNumbers">Create</el-button>
            <el-button
              type="default"
              class="hidden-xs-only"
              @click="cancelOperation"
            >
              Cancel
            </el-button>
            <el-button
              type="default"
              icon="el-icon-close"
              class="hidden-sm-and-up"
              @click="cancelOperation"
            ></el-button>
          </div>
        </div>
      </div>

      <el-form>
        <div class="inline-form-group">
          <el-radio-group v-model="searchType" class="mb-10">
            <el-radio label="inventory">
              <span class="black-text">Search inventory</span>
            </el-radio>
            <el-radio label="exact">
              <span class="black-text">Search exact number</span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="inline-form-group" v-if="searchType === 'inventory'">
          <el-col :span="7">
            <dads-select
              v-model="createForm.state"
              :value="createForm.state"
              placeholder="Select state"
              @change="fetchRateCenters"
              filterable
            >
              <template slot="prefix">State</template>
              <el-option
                v-for="(state, index) in states"
                :key="index"
                :value="state.abbreviation"
                :label="state.name"
              />
            </dads-select>
          </el-col>
          <el-col :span="1" />
          <el-col :span="16">
            <dads-select
              v-model="createForm.rateCenter"
              :value="createForm.rateCenter"
              placeholder="Select rate center"
              @change="getCoverage"
              filterable
            >
              <template slot="prefix">Rate center</template>
              <el-option
                v-for="(center, index) in rateCenters"
                :key="index"
                :value="center"
                :label="center"
              />
            </dads-select>
          </el-col>
        </div>

        <div class="inline-form-group" v-if="searchType === 'inventory'">
          <el-col :span="24">
            <dads-select
              v-model="createForm.area"
              :value="createForm.area"
              placeholder="Select npa-nxx"
              v-loading="optionsLoading"
              @change="getInventory"
              filterable
            >
              <template slot="prefix">NPA-NXX</template>
              <el-option
                v-for="(area, index) in areaOptions"
                :key="index"
                :value="area.npa + area.nxx"
                :label="
                  area.npa +
                    ' - ' +
                    area.nxx +
                    ' - XXXX ' +
                    '( ' +
                    area.count +
                    ' available)'
                "
              />
            </dads-select>
          </el-col>
        </div>

        <div v-else class="inline-form-group flex column align-baseline">
          <div class="el-input el-input--prefix">
            <input
              v-model="numberSearch"
              type="text"
              autocomplete="off"
              placeholder="Enter number"
              class="el-input__inner"
              v-mask="'(XXX)-XXX-XXXX'"
            />
            <span class="el-input__prefix">Number</span>
          </div>
          <el-tag>You may enter an X to specify a wildcard digit</el-tag>
        </div>

        <dads-select
          v-model="createForm.branchId"
          placeholder="Select a branch"
          allow-create
          filterable
        >
          <template slot="prefix">Branch</template>
          <el-option
            v-for="(item, index) in branchOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </dads-select>

        <h2 class="form-section-header">Choose numbers</h2>

        <el-transfer
          v-model="createForm.numbers"
          :data="numberOptions"
          v-loading="numbersLoading"
          :titles="['Available', 'Assigned']"
          filterable
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import rateCentersList from "@/ref/rate-centers";
import stateList from "@/ref/states";
import DadsSelect from "@/components/select";
import feathersClient from "@/feathers/feathers-client";
import {debounce} from "lodash";
import {phoneNumberFormatter} from "@/globals/globals";
export default {
  name: "CreatePhoneNumber",
  props: {
    createProcessing: { required: true },
    createVisible: { required: true },
    branchOptions: { required: true },
    clearFields: { required: true }
  },
  components: {
    DadsSelect
  },
  data() {
    return {
      optionsLoading: false,
      numbersLoading: false,
      rateCenters: [],
      numberOptions: [],
      areaOptions: [],
      states: stateList,
      createForm: {
        state: "",
        rateCenter: "",
        area: "",
        numbers: [],
        branchId: ""
      },
      searchType: 'inventory',
      numberSearch: '',
    };
  },
  async created() {
    await this.getDefaultBranch();
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },
  watch: {
    clearFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetFields();
          this.getDefaultBranch();
        }
      }
    },
    createVisible: {
      handler(val) {
        if (val) {
          this.getDefaultBranch();
        }
      }
    },
    numberSearch: debounce(function () {
      if(this.numberSearch) {
        let searchNum = this.numberSearch.replace(/['":/{}()[|\-.<>?_=+ \]]/g, '');
        if(searchNum.length === 10){
          this.getInventory(searchNum);
        }
      }
    }, 500),
    searchType: {
      handler() {
        this.numberSearch = '';
        this.createForm.area = '';
        this.createForm.state = '';
        this.createForm.rateCenter = '';
        this.numberOptions = [];
      }
    }
  },
  methods: {
    async getDefaultBranch() {
      try {
        const [defaultBranch] = await feathersClient.service("branches").find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });
        this.createForm.branchId = defaultBranch.id;
      } catch (error) {
        console.log(error)
      }
    },
    resetFields() {
      this.optionsLoading = false;
      this.numbersLoading = false;
      this.rateCenters = [];
      this.numberOptions = [];
      this.areaOptions = [];
      Object.keys(this.createForm).forEach(key => {
        this.createForm[key] = Array.isArray(this.createForm[key]) ? [] : "";
      });
    },
    orderNumbers() {
      const orderBody = {
        tenantId: this.selectedTenant.id,
        numbers: this.createForm.numbers,
        branchId: this.createForm.branchId
      };
      this.$emit("orderNumbers", orderBody);
    },
    cancelOperation() {
      this.resetFields();
      this.$emit("cancelOperation");
    },
    fetchRateCenters() {
      this.createForm.rateCenter = "";
      this.createForm.area = "";
      this.createForm.numbers = [];
      this.numberOptions = [];
      this.rateCenters = rateCentersList[this.createForm.state].sort();
    },
    numberFormatter(number) {
      return phoneNumberFormatter(number);
    },
    getCoverage() {
      const numberOrderingService = feathersClient.service("tn-ordering");
      this.optionsLoading = true;
      this.numberOptions = [];
      this.createForm.numbers = [];
      const params = {
        query: {
          context: "coverage",
          rateCenter: this.createForm.rateCenter,
          state: this.createForm.state
        }
      };
      numberOrderingService.find(params).then(res => {
        //if there are no results let user know there are no available numbers
        if (!res.length) {
          this.$notify({
            title: "No Available Numbers",
            message:
              "There Are No Available Numbers For the Selected Rate Center!",
            type: "error"
          });
          this.optionsLoading = false;
          this.areaOptions = "";
          this.numberOptions = [];
          this.createForm.area = "";
        } else {
          this.areaOptions = res;
          this.createForm.area = "";
          this.createForm.numbers = [];
          this.optionsLoading = false;
        }
      });
    },
    getInventory(searchNum) {
      const numberOrderingService = feathersClient.service("tn-ordering");
      this.numbersLoading = true;
      let params = {
        query: {
          context: "inventory",
          rateCenter: this.createForm.rateCenter,
          state: this.createForm.state,
        }
      };
      this.searchType === 'inventory' ? params.query.npanxx = this.createForm.area : params.query.number = searchNum;
      numberOrderingService.find(params).then(res => {
        let transferNumbers = [];
        res.forEach(n => {
          transferNumbers.push({
            key: n.telephoneNumber,
            label: this.numberFormatter(n.telephoneNumber),
            disabled: false
          });
        });
        this.numberOptions = transferNumbers;
        this.numbersLoading = false;
      })
        .catch(() => {
          this.$notify({
            title: "No Available Numbers",
            message:
              "There Are No Available Numbers!",
            type: "error"
          });
          this.numbersLoading = false;
        })
    }
  }
};
</script>
